import { render, staticRenderFns } from "./UnstoppableDomainBuyOverlay.vue?vue&type=template&id=03980f86&scoped=true"
import script from "./UnstoppableDomainBuyOverlay.vue?vue&type=script&lang=js"
export * from "./UnstoppableDomainBuyOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03980f86",
  null
  
)

export default component.exports